/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as WizardHorizontal } from './wizard-horizontal.story';
export { default as WizardVertical } from './wizard-vertical.story';
export { default as WizardHorizontalSmall } from './wizard-horizontal-small.story';
export { default as WizardVerticalSmall } from './wizard-vertical-small.story';
export { default as WizardErrorState } from './wizard-error-state.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import WizardErrorStateSourceRaw from './wizard-error-state.story?raw';
import WizardHorizontalSourceRaw from './wizard-horizontal.story?raw';
import WizardHorizontalSmallSourceRaw from './wizard-horizontal-small.story?raw';
import WizardVerticalSourceRaw from './wizard-vertical.story?raw';
import WizardVerticalSmallSourceRaw from './wizard-vertical-small.story?raw';

export const WizardHorizontalSource = removeLicenseHeader(
  WizardHorizontalSourceRaw,
);

export const WizardVerticalSource = removeLicenseHeader(
  WizardVerticalSourceRaw,
);

export const WizardHorizontalSmallSource = removeLicenseHeader(
  WizardHorizontalSmallSourceRaw,
);

export const WizardVerticalSmallSource = removeLicenseHeader(
  WizardVerticalSmallSourceRaw,
);

export const WizardErrorStateSource = removeLicenseHeader(
  WizardErrorStateSourceRaw,
);
